import { UIComponentViewImpl } from '../uicomponentview';
import { UIDataModel } from '../uicomponent';
import { TextComponentProps, TextComponentState, TextComponentHandler } from './textcomponent';
import { TextCSSStyle } from './textcss';
import './textcss.css';
import * as React from 'react';

export class TextViewImpl extends UIComponentViewImpl<UIDataModel>
{
    bindHandlers()
    {
        this.onChange = this.onChange.bind(this);
    }

    draw(props: TextComponentProps, state: TextComponentState, cssStyle: TextCSSStyle): JSX.Element | boolean
    {   
         return (
                <div style={cssStyle.getWrapperCSSStyle()}>
                    {props.label !== "" && <label style={cssStyle.getTextLabelCSSStyle()}>{props.label}
                        {props.isRequired && !props.isDisabled && <label style={cssStyle.getLabelStartCSSStyle()}>
                           {"*"}
                        </label>}
                </label>}
                    
                    <input onKeyDown={props.inputType === "number" ? this.onKeyPress : ()=>""} autoFocus={true} disabled={props.isDisabled}  value={state.value} type={props.inputType} onChange={this.onChange} style={state.errorMessage !== undefined ? cssStyle.getErrorCSSStyle() : cssStyle.getTextCSSStyle(state.class === "" ? false : true , props.isDisabled)} placeholder={props.hint}/>

                    {
                        state.errorMessage !== undefined && <div style={cssStyle.getErrorTextDivCSSStyle()}>
                        <label style={cssStyle.getErrorTextCSSStyle(this.getContext().getUserContext().getLanguage())}>{state.errorMessage}</label> </div>}
                </div>
       );
    }

    onChange(event: any)
    {
        (this.getUIComponentHandler() as TextComponentHandler).onChange(event.target.value);
    }
     onKeyPress(event:any)
    {
        if(event.keyCode === 69 || event.keyCode === 187 || event.keyCode === 190 || 
            event.keyCode === 189 || (event.ctrlKey && event.keyCode === 90) ||
            (event.ctrlKey && event.keyCode === 67) || (event.ctrlKey && event.keyCode === 86) ||
            (event.ctrlKey && event.keyCode === 88))
        {
            event.preventDefault();
        }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/text/textview.tsx